import _ from 'lodash';
import axios from 'axios';

export default (getOptions) => ({
    Download: () => axios.get('/api/user/resource/pvt/download/list', _.merge(getOptions(), {
        responseType: 'blob',
    })),
});
